import { CartItem } from 'models/CartItem';
import styles from '../styles.scss';
import Price from 'components/Shared/Price';
import { getRentalUnit } from 'components/Shared/Price/selector';
import cn from 'classnames';
import { getOriginalPrice, getPrice } from '../utils';

interface Props {
  item: CartItem;
  isLoading: boolean;
  relations: CartItem[];
}

export const PriceContainer = ({ item, isLoading, relations }: Props) => {
  return (
    <div
      className={cn(styles.priceContainer, {
        [styles.multiplePriceLines]:
          !!item.originalPrice.discount || item.unitPrice < item.originalPrice.amount,
        [styles.loading]: isLoading
      })}
    >
      {!!item.originalPrice.discount && (
        <strong>
          <div>-{item.originalPrice.discount}%</div>
        </strong>
      )}
      {(item.unitPrice < item.originalPrice.amount || !!item.originalPrice.discount) && (
        <Price price={getOriginalPrice(item, relations)} appearance="lineThrough" />
      )}
      <strong>
        <Price price={getPrice(item, relations)} appearance="discount" unit={getRentalUnit(item)} />
      </strong>
    </div>
  );
};
